import { AfterViewInit, Directive, HostListener, OnInit } from '@angular/core';

@Directive({
  selector: '[appHomebanner]'
})
export class HomebannerDirective implements OnInit, AfterViewInit {
  liIndex: number;
  xDown = null;
  yDown = null;
  windowType: string;
  constructor() {
    this.liIndex = 1;
  }
  ngOnInit() {
    this.xDown = null;
    this.yDown = null;
    this.liIndex = 1;
  }

  ngAfterViewInit() {
    this.adjustBanners();
  }



  @HostListener('window:resize') onResize() {
    this.xDown = null;
    this.yDown = null;
    this.liIndex = 1;
    this.adjustBanners();
  }

  @HostListener('window:orientationchange') onOrientationChange() {
    this.xDown = null;
    this.yDown = null;
    this.liIndex = 1;
    this.adjustBanners();
  }

  adjustBanners() {
    // Device Detection
    const ww = document.body.clientWidth;
    if (ww <= 992) {
      this.windowType = "mobile";
      document.querySelector('.slider_container ul').setAttribute('id','mobile_slider');
    } else {
      this.windowType = "desktop";
      document.querySelector('.slider_container ul').setAttribute('id','desktop_slider');
    }

    const sliderContainer: HTMLElement = document.querySelector('.slider_container');
    let containerWidth = sliderContainer.offsetWidth;

    let sliderUL: HTMLElement = document.querySelector('.slider_container ul#desktop_slider');


    if (this.windowType === "mobile") {
      sliderUL = document.querySelector('.slider_container ul#mobile_slider');
    }

    if(sliderUL===null) return;

    const sliderLis: NodeListOf<HTMLElement> = sliderUL.querySelectorAll('li')



    if (this.liIndex == 1) {
      sliderUL.style.left = '0px';
    }

    let liCount = sliderLis.length;
    let ulWidth = containerWidth * liCount;
    let liWidth = containerWidth;

    // const listImage:HTMLElement=document.querySelector('.slider_container li img');

    // sliderContainer.style.height=listImage.offsetHeight.toString()+'px';

    sliderUL.style.width = ulWidth + 'px';

    sliderLis.forEach((li: HTMLElement) => {
      li.style.width = liWidth + 'px';
    });

    const sliderELement: HTMLElement = document.querySelector('#slider');
    let prevElements = sliderELement.querySelectorAll('.prev');

    if (prevElements.length > 0) {

      prevElements.forEach((ele) => {
        ele.remove();
      });
    }

    let nextElements = sliderELement.querySelectorAll('.next');

    if (nextElements.length > 0) {

      nextElements.forEach((ele) => {
        ele.remove();
      });
    }

    let navigatorElements = sliderELement.querySelectorAll('.navigator');

    if (navigatorElements.length > 0) {

      navigatorElements.forEach((ele) => {
        ele.remove();
      });
    }
    if (liCount > 1) {
      sliderELement.insertAdjacentHTML("beforeend", '<div class="navigator"></div>');
      sliderELement.insertAdjacentHTML("afterbegin", '<span class="prev"></span><span class="next"></span>');


      const prevArrow: HTMLElement = document.querySelector('.prev');

      const nextArrow: HTMLElement = document.querySelector('.next');


      prevArrow.addEventListener("click", () => {

        this.liIndex <= 1 ? this.liIndex = liCount : this.liIndex -= 1;
        let inc = (this.liIndex - 1) * liWidth;
        let incStr = inc == 0 ? 0 + 'px' : -inc + 'px';
        sliderUL.style.left = incStr;

      });

      nextArrow.addEventListener("click", () => {

        this.liIndex >= liCount ? this.liIndex = 1 : this.liIndex += 1;

        let inc = (this.liIndex - 1) * liWidth;
        let incStr = inc == 0 ? 0 + 'px' : -inc + 'px';
        sliderUL.style.left = incStr;
      });

      sliderUL.addEventListener("touchstart", (event) => { this.handleTouchStart(event); }, false);
      sliderUL.addEventListener("touchmove", (event) => { this.handleTouchMove(event); }, false);
    }

  }

  getTouches(evt) {
    return evt.touches ||
      evt.originalEvent.touches;
  }

  handleTouchStart(evt) {
    const firstTouch = this.getTouches(evt)[0];
    this.xDown = firstTouch.clientX;
    this.yDown = firstTouch.clientY;
  };

  handleTouchMove(evt) {
    if (!this.xDown || !this.yDown) {
      return;
    }

    var xUp = evt.touches[0].clientX;
    var yUp = evt.touches[0].clientY;

    var xDiff = this.xDown - xUp;
    var yDiff = this.yDown - yUp;

    let prevArrow: HTMLElement = document.querySelector('.prev');

    let nextArrow: HTMLElement = document.querySelector('.next');

    if (Math.abs(xDiff) > Math.abs(yDiff)) {/*most significant*/
      if (xDiff > 0) {
        /* left swipe */
        nextArrow.click();
      } else {
        /* right swipe */
        prevArrow.click();
      }
    } else {
      if (yDiff > 0) {
        /* up swipe */
      } else {
        /* down swipe */
      }
    }
    /* reset values */
    this.xDown = null;
    this.yDown = null;
  };


}
